module.exports = __webpack_public_path__ + "img/about_cletter_img01.73aaeb83.jpg";